import * as React from 'react';
import Icon from '../Icon';

export const Avatar = ({user, color, size = 40}) => {
  if (user.avatar) {
    return (
      <div
        style={{
          background: `url(${user.avatar.path}) center center / cover no-repeat`,
          width: size,
          height: size,
          borderRadius: size / 2,
        }}
      />
    );
  }

  return <Icon name="user-circle" size={size} color={color || 'secondary'} />;
};

export default Avatar;
